<template>
  <span v-if="showLogo" class="league-mark" v-bind="$attrs">
    <img
      :src="activeLogoUrl"
      :alt="`${displayLeague} logo`"
      class="league-mark__image"
      loading="lazy"
      @error="handleLogoError"
    />
  </span>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { normalizeLeague } from '@/lib/quickStats/teamSlug'

const props = defineProps({
  league: {
    type: String,
    default: ''
  },
  logoUrl: {
    type: String,
    default: ''
  }
})

const activeLogoUrl = ref('')

const displayLeague = computed(() => normalizeLeague({ league: props.league }) || props.league || 'League')
const normalizedKey = computed(() => String(displayLeague.value || '').toUpperCase())
const preferredLeagueLogoUrl = computed(() => {
  if (normalizedKey.value === 'NFL') return 'https://services-a5nx5.ondigitalocean.app/api/v1/logo/nfl'
  if (normalizedKey.value === 'NCAAF') return 'https://services-a5nx5.ondigitalocean.app/api/v1/logo/ncaaf'
  return ''
})

const showLogo = computed(() => Boolean(activeLogoUrl.value))

watch(
  [() => props.logoUrl, () => props.league],
  () => {
    activeLogoUrl.value = preferredLeagueLogoUrl.value || props.logoUrl || ''
  },
  { immediate: true }
)

function handleLogoError() {
  if (activeLogoUrl.value === preferredLeagueLogoUrl.value && props.logoUrl && props.logoUrl !== preferredLeagueLogoUrl.value) {
    activeLogoUrl.value = props.logoUrl
    return
  }

  activeLogoUrl.value = ''
}
</script>

<style scoped>
.league-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.league-mark__image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
